import { CouponModalState } from '../../models/coupon/coupon_modal_state';
import { CouponModalAction } from './coupon_modal_action';

const CommonModal = (window as any)._modal;

export class CouponModal extends CommonModal {
  constructor() {
    super('data-coupon-modal-trigger', 'data-coupon-modal-close');
  }

  close(_modal: any) {
    const initState = new CouponModalState({
      shouldShowModal: true,
      coupons: [],
      catalogItemCode: ''
    });

    CouponModalAction.DISPLAY_COUPON_MODAL_EVENT.trigger(initState.getModel());
  }
}
